import React from "react";
import ActivityAction from "../ActivityAction/ActivityAction";

const UpdateActivityItem = ({ document, onClick, isNewField, isSubFile, subFile, hasAccess }) => {
  const { id, title } = document;
  return (
    <>
      {isNewField
        ? `added a new field to -`
        : isSubFile
        ? `edited${subFile.length === 1 ? ` a sub-file -` : ``}`
        : `made changes to -`}
      <ActivityAction
        {...{
          title: isSubFile ? (subFile.length === 1 ? subFile[0].title : `${subFile.length} sub-files`) : title,
          onClick: () => onClick(id),
          isDocument: true,
          inTrash: document.inTrash,
          hasAccess,
        }}
      />
      {isSubFile ? `in ${title}` : null}
    </>
  );
};

export default UpdateActivityItem;
